import React, { useMemo } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const STRIPE_KEY =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_STRIPE_LIVE_KEY
    : process.env.REACT_APP_STRIPE_TEST_KEY;

/**
 * Wraps children in Stripe Elements.
 * loadStripe() is called lazily on first render of this component,
 * NOT at app startup.
 */
export default function StripeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const stripePromise = useMemo(() => loadStripe(STRIPE_KEY!), []);
  return <Elements stripe={stripePromise}>{children}</Elements>;
}
